import { Alert, Button, Flex } from '@chakra-ui/react'
import { useState } from 'react'

import { useCancelContract } from '@/hooks/useWizard'
import { Cancellation } from '../icons'

export const CancelContract = ({ insuranceId, callback }: { insuranceId: number, callback: () => void }) => {
  const [confirmCancel, setConfirmCancel] = useState<boolean>(false)

  const { mutateAsync: cancelContract, isLoading: isCancelling, isError } = useCancelContract()

  const handleCancelConfirm = () => {
    setConfirmCancel(true)
  }

  const handleCancelContract = () =>
    cancelContract(insuranceId)
      .then((resp) => {
        if (resp.success) {
          callback()
        }
      })
      .finally(() => {
        setConfirmCancel(false)
      })

  return (
    <>
      {!confirmCancel && (
        <Button variant="outline" colorScheme="red" onClick={handleCancelConfirm}>
          <Cancellation />
          Stornovat pro chybu ve smlouvě
        </Button>
      )}

      {confirmCancel && (
        <Flex sx={{ gap: 2 }}>
          <Button
            variant="solid"
            colorScheme="red"
            onClick={handleCancelContract}
            disabled={isCancelling}
          >
            <Cancellation />
            {isCancelling ? 'Stornuji...' : 'Opravdu stornovat?'}
          </Button>

          {!isCancelling && (
            <Button variant="outline" onClick={() => setConfirmCancel(false)}>
              Nestornovat
            </Button>
          )}
        </Flex>
      )}

      {isError && <Alert colorScheme="red">Při stornování došlo k chybě</Alert>}
    </>
  )
}
